import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { withConfig } from 'src/withConfig';

interface CardBodyListItemPropsType {
    variant: DefaultComponentVariantType | null;
}

const setCardBodyListItem = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            margin-bottom: 4px;
            border-radius: ${theme.star.radius.medium};
        `;
    }
    return css`
        border-bottom: 1px solid ${theme.star.racingNextOff.raceBox.borderColor};
        &:last-of-type {
            border-color: ${theme.star.racingNextOff.raceBox.borderColorTertiary};
        }
    `;
};

export const CardBodyListItem = withConfig(theme => styled('li', { label: 'CardBodyListItem' })<CardBodyListItemPropsType>`
    ${({ variant }): SerializedStyles => setCardBodyListItem(variant, theme)}
    align-items: center;
    background-color: ${theme.star.selectionsGroup.bgColor};
    display: flex;
    flex-flow: row nowrap;
    height: 48px;
    justify-content: space-between;
`);
